/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { GetDeliveryResponseDtoParticipationEntitlementsInner } from './get-delivery-response-dto-participation-entitlements-inner';

/**
 * 
 * @export
 * @interface UpdateDeliveryStatusResponseDto
 */
export interface UpdateDeliveryStatusResponseDto {
    /**
     * Delivery ID
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'deletedAt': string;
    /**
     * Participation ID this delivery belongs to
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'participationId': string;
    /**
     * Event/Challenge title associated with this delivery
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'eventName'?: string;
    /**
     * Delivery recipient name
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationName': string;
    /**
     * Delivery contact number
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationContactNumber': string;
    /**
     * Destination country
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationCountry': string;
    /**
     * Destination country code
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationCountryCode': string;
    /**
     * Destination province
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationProvince': string;
    /**
     * Destination province code
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationProvinceCode': string;
    /**
     * Destination city
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationCity': string;
    /**
     * Destination city code
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationCityCode': string;
    /**
     * Destination barangay
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationBarangay': string;
    /**
     * Destination barangay code
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationBarangayCode': string;
    /**
     * Destination street address
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationStreet': string;
    /**
     * Additional destination address line (apartment, unit, floor, building)
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationAddressLine2'?: string;
    /**
     * Destination postal code
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationPostalCode': string;
    /**
     * Source API used for destination address data
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationSourceApi': UpdateDeliveryStatusResponseDtoDestinationSourceApiEnum;
    /**
     * Origin name
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'originName'?: string;
    /**
     * Origin contact number
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'originContactNumber'?: string;
    /**
     * Origin country
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'originCountry'?: string;
    /**
     * Origin country code
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'originCountryCode'?: string;
    /**
     * Origin province
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'originProvince'?: string;
    /**
     * Origin province code
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'originProvinceCode'?: string;
    /**
     * Origin city
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'originCity'?: string;
    /**
     * Origin city code
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'originCityCode'?: string;
    /**
     * Origin barangay
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'originBarangay'?: string;
    /**
     * Origin barangay code
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'originBarangayCode'?: string;
    /**
     * Origin street address
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'originStreet'?: string;
    /**
     * Origin postal code
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'originPostalCode'?: string;
    /**
     * Source API used for origin address data
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'originSourceApi'?: UpdateDeliveryStatusResponseDtoOriginSourceApiEnum;
    /**
     * Current delivery status
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'status': UpdateDeliveryStatusResponseDtoStatusEnum;
    /**
     * Tracking number provided by courier
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'trackingNo'?: string;
    /**
     * Tracking link URL
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'trackingLink'?: string;
    /**
     * Delivery courier/service name
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'deliveryCourier'?: string;
    /**
     * Timestamp when delivery was set to on standby
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'onStandbyAt'?: string;
    /**
     * Timestamp when delivery status changed to shipping soon
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'shippingSoonAt'?: string;
    /**
     * Timestamp when delivery went in transit
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'inTransitAt'?: string;
    /**
     * Timestamp when delivery went out for delivery
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'outForDeliveryAt'?: string;
    /**
     * Timestamp when delivery was completed
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'deliveredAt'?: string;
    /**
     * Timestamp when delivery was cancelled
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'cancelledAt'?: string;
    /**
     * Array of image URLs for delivery proof
     * @type {Array<string>}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'imageUrls': Array<string>;
    /**
     * Whether the delivery has been confirmed by the user
     * @type {boolean}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'isConfirmedByUser': boolean;
    /**
     * Whether finisher shirt is included in this delivery
     * @type {boolean}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'shouldIncludeFinisherShirt'?: boolean;
    /**
     * Finisher shirt size if included
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'finisherShirtSize'?: string;
    /**
     * Whether medal is included in this delivery
     * @type {boolean}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'shouldIncludeMedal'?: boolean;
    /**
     * List of entitlements included in this delivery
     * @type {Array<GetDeliveryResponseDtoParticipationEntitlementsInner>}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'participationEntitlements'?: Array<GetDeliveryResponseDtoParticipationEntitlementsInner>;
    /**
     * Destination recipient name (who will receive the package)
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationRecipient'?: string;
    /**
     * Destination contact number
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationContact'?: string;
    /**
     * Complete destination address (street, address line 2, barangay, city, province, postal code, country)
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'destinationAddress'?: string;
    /**
     * User nickname from participation
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'userNickname'?: string;
    /**
     * User full name from participation
     * @type {string}
     * @memberof UpdateDeliveryStatusResponseDto
     */
    'userFullName'?: string;
}

export const UpdateDeliveryStatusResponseDtoDestinationSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type UpdateDeliveryStatusResponseDtoDestinationSourceApiEnum = typeof UpdateDeliveryStatusResponseDtoDestinationSourceApiEnum[keyof typeof UpdateDeliveryStatusResponseDtoDestinationSourceApiEnum];
export const UpdateDeliveryStatusResponseDtoOriginSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type UpdateDeliveryStatusResponseDtoOriginSourceApiEnum = typeof UpdateDeliveryStatusResponseDtoOriginSourceApiEnum[keyof typeof UpdateDeliveryStatusResponseDtoOriginSourceApiEnum];
export const UpdateDeliveryStatusResponseDtoStatusEnum = {
    OnStandby: 'on_standby',
    ShippingSoon: 'shipping_soon',
    InTransit: 'in_transit',
    OutForDelivery: 'out_for_delivery',
    Delivered: 'delivered',
    Cancelled: 'cancelled'
} as const;

export type UpdateDeliveryStatusResponseDtoStatusEnum = typeof UpdateDeliveryStatusResponseDtoStatusEnum[keyof typeof UpdateDeliveryStatusResponseDtoStatusEnum];


